import { render, staticRenderFns } from "./approveDetail_feedbackDetail.vue?vue&type=template&id=778f7064&scoped=true"
import script from "./approveDetail_feedbackDetail.vue?vue&type=script&lang=js"
export * from "./approveDetail_feedbackDetail.vue?vue&type=script&lang=js"
import style0 from "./approveDetail_feedbackDetail.vue?vue&type=style&index=0&id=778f7064&scoped=true&lang=scss"
import style1 from "./approveDetail_feedbackDetail.vue?vue&type=style&index=1&id=778f7064&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778f7064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('778f7064')) {
      api.createRecord('778f7064', component.options)
    } else {
      api.reload('778f7064', component.options)
    }
    module.hot.accept("./approveDetail_feedbackDetail.vue?vue&type=template&id=778f7064&scoped=true", function () {
      api.rerender('778f7064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/storeFeedback/approveReport/approveDetail_feedbackDetail.vue"
export default component.exports